import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button, RadioGroup, TagBox } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import SelectField from "../../../../Shared/fields/SelectField";
import DataGrid, {
  Column,
} from "devextreme-react/ui/data-grid";
import Modal from "../../../Trabajador/Solicitudes/SolicitudesPendientes/modal";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";
import { roleTypes, workerPermits } from "../../../../../helpers/constants";
import {
  doGetSolicitudes,
  doAcceptSolicitud,
  doRejectSolicitud,
} from "./actions";
import {
  openCloseSelectRoles,
  setSelectedTrabajador,
  openCloseModalEditarRoles,
  setLoadingResumeData,
  loading,
  doUpdateUserRoles,
} from "../AsignacionRoles/actions";
import validaciones from "../../../../../helpers/validaciones";
import constants from "../../../../../helpers/constants";
import SelectRoles from "../AsignacionRoles/selectRoles";
import { getRolesByCompanyRutAndUser } from "../../../../../services/userRolesApi"
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

const ActionButton = (props) => (
  <Button
    type={props.type}
    text={props.text}
    onClick={props.onClick}
    style={props.style}
    render={(btn) => (
      <div
        style={{
          padding: "7px 0px 0px 0px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",

        }}
      >{btn.text}
      </div>
    )}
  />
);

class AprobarSolicitudes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      disableButton: false,
      step: 0,
      body: null,
      selectedItem: null,
      selectedType: undefined,
      selectedRol: undefined,
      roleType: null,
      permissions: null,
      blockedRoles: [],
      reloadSolicitudes: false,
    };
    this.tableRef = React.createRef();
    props.dispatch(doGetSolicitudes(this.props.companyId));
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.companyId !== prevProps.companyId) {
      this.props.dispatch(doGetSolicitudes(this.props.companyId));
    }
    if (prevProps.companyId !== this.props.companyId) {
        this.props.dispatch(push(paths.root))
    }
  }

  handleGestion = async (user) => {
    //Edicion del usuario antes de mostrar el popup
    this.props.dispatch(openCloseModalEditarRoles(true, user));
    user.Roles = []
    const request = await getRolesByCompanyRutAndUser(user.CompanyRut, user.RUT)
    const dataTrabajador = await request.json()
    let blockedRoles = [];
    dataTrabajador.roles.forEach(item => {
      blockedRoles.push(this.props.allRoles.find(c => c.Id === parseInt(item)))
    });
    let permisosSolicitados = user && user.Permits
                                ? user.Permits.includes("[")
                                  ? JSON.parse(user.Permits)
                                  : [JSON.parse(user.Permits)]
                                : []
    permisosSolicitados.forEach(item => {
      user.Roles.push(this.props.allRoles.find(r => r.Id === item))
    });

    this.props.dispatch(setSelectedTrabajador(user));
    this.setState({
      modalOpen: true,
      blockedRoles: blockedRoles,
      selectedItem: user,
      roleType: user && user.RoleType && roleTypes.find(r => r.Code === user.RoleType)
        ? roleTypes.find(r => r.Code === user.RoleType).Id
        : 1,
    });
  }

  handleCloseModal = () => {
    this.setState({ modalOpen: false });
    // timeout to let the close animation play
    setTimeout(() => {
      this.setState({
        modalOpen: false,
        body: null,
        disableButton: false,
        step: 0,
        selectedItem: null,
        selectedRol: undefined,
        selectedType: undefined,
      });
    }, 500);
    this.props.dispatch(openCloseModalEditarRoles(false, {}));
  }

  handleRechazo = () => {
    const user = this.state.selectedItem;
    let solData = {
      Rut: user.RUT,
      Id: user.IdRequest,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName,
      CompanyRut: user.CompanyRut,
      CompanyName: this.props.listaEmpresas.find(item => item.RutEmpresa === user.CompanyRut).Nombre,
    }
    this.props.dispatch(doRejectSolicitud(solData, user.FromUser));
    this.handleCloseModal();
  }

  handleChange = (event) => {
    this.setState({
      selectedType: event.value,
    });
  }

  handleTypeChange = (event) => {
    this.setState({
      roleType: event.value,
    });
  }

  handlePermissionsChange = (event) => {
    this.setState({
      permissions: event.value,
    });
  }

  handleRolChange = (event) => {
    const selectedItems = event.component.option("selectedItems");
    this.setState({
      selectedRol: selectedItems,
      disableButton: selectedItems.length === 0,
    });
  }

  handleAssignarRol = () => {
    const user = this.state.selectedItem;
    let trabajador = this.props.selectedTrabajador
    let originalPermissions = trabajador && trabajador.Roles && trabajador.Roles.find(r => r.Id === 6)
    ? 6
    : trabajador && trabajador.Roles && trabajador.Roles.find(r => r.Id === 8)
      ? 8
      : null

    let defPermissions = this.state.permissions || originalPermissions
    let permissionsRol = [defPermissions && this.props.allRoles.find(rol => rol.Id === parseInt(defPermissions))]

    let assignarObject = {
      Id: user.IdRequest,
      Email: user.Email,
      Password: user.RUT,
      FirstName: user.FirstName,
      LastName: user.LastName,
      Rut: user.RUT,
      IdRol: user.RoleType === "PER_TRABAJADOR"
              ? this.state.blockedRoles.filter(r => r.Id !== 6 && r.Id !== 8).concat(permissionsRol)
              : trabajador.Roles.concat(this.state.blockedRoles)
      ,
      Phone: user.CellPhoneNumber,
      CompanyRut: user.CompanyRut,
      CompanyName: this.props.listaEmpresas.find(item => String(item.RutEmpresa).toLocaleLowerCase() === String(user.CompanyRut).toLowerCase()).Nombre,
      RelationType: defPermissions === 6 ? "Interno" : "Externo",
      RelationTypeCode: defPermissions === 6 ? "INT" : "EXT"
    }

    this.props.dispatch(doAcceptSolicitud(assignarObject));
    this.handleCloseModal();
  }

  handleFilterChange = (text) => {
    this.tableRef.searchByText(text);
  }

  handleRoles = (e) => {
    const newData = { ...this.props.selectedTrabajador };
    const newRoles = e.value.map((itemId) => this.props.allRoles.find((i) => i.Id === itemId));
    newData.Roles = newRoles;
    newData.edited = true;
    this.props.dispatch(setSelectedTrabajador(newData));
  }

  renderModal = () => {
    const {
      modalOpen,
      selectedItem
    } = this.state;

    let workerPermitsEdited = []
    workerPermits.forEach(item => {
    workerPermitsEdited.push({ Id: item.Id, Name: `${item.Name + ": " + item.Description}`});
    });

    let body = (<div id="handleGestion" className="zero row solicitudes-modal-info">
    <span>Asigna el tipo de rol y permiso para el trabajador</span>

    <div style={{ position: "absolute",  marginTop: 10, textAlign: "left", width: "100%" }}>
      {this.props.isLoading && <LoadingOverlay />}
      <TextField
        label="Usuario"
        disabled
        value={`${selectedItem ? selectedItem.FirstName : ""} ${selectedItem ? selectedItem.LastName : ""}`}
      />
      <TextField
        label="Rut"
        disabled
        value={selectedItem ? selectedItem.RUT : ""}
      />
      <TextField
        label="Tipo de Rol"
        disabled
        value={selectedItem && selectedItem.RoleType === "PER_TRABAJADOR" ? "Trabajador" : "Empresa"}
      />

      {selectedItem && selectedItem.RoleType === "PER_TRABAJADOR"
        ? <SelectField
            label="Permisos"
            onChange={this.handlePermissionsChange}
            items={workerPermitsEdited}
            required
            valueExpr="Id"
            displayExpr="Name"
            defaultValue={selectedItem && selectedItem.Permits
              ? parseInt(selectedItem.Permits)
              : null}
          />
      : <SelectRoles
          title="Permisos"
          selectedItems={(this.props.selectedTrabajador &&
                          this.props.selectedTrabajador.Roles &&
                          this.props.selectedTrabajador.Roles.map((r) => r.Id)) || []}
          dataSource={this.props.roles && this.props.roles.map(r => ({...r, disabled: this.state.blockedRoles ? this.state.blockedRoles.find(c => c.Id === r.Id) : false}))}
          onSelection={this.handleRoles}
          openClose={(isOpen) => this.props.dispatch(openCloseSelectRoles(isOpen))}
          open={this.props.isOpenSelectRoles}
          onSelectionChanged={this.handleRolChange}
          preExistingRoles={(this.state.blockedRoles &&
                             this.state.blockedRoles.map((r) => r.Id)) || []}
        />
      }
    </div>
    </div>)

    return (<Modal
      title={"Gestión de usuarios"}
      disableNext={this.state.disableButton}
      isLastPage={false}
      handleSuccess={this.handleAssignarRol}
      showCancel={true}
      type="gestion"
      cancelText="Rechazar"
      height={550}
      acceptText={"Aprobar"}
      body={body}
      width={630}
      onClose={this.handleCloseModal}
      open={modalOpen}
      handleRechazo={this.handleRechazo}
    />);
  }

  handleAsignar = () => {
    this.props.dispatch(doUpdateUserRoles(this.props.selectedTrabajador, this.props.companyId));
  }


  render() {
    let solicitudesEdited = this.props.solicitudes
    solicitudesEdited.forEach(item => {
      item.tipoDeRol = item.RoleType
      ? item.RoleType === "PER_EMPRESA"
        ? "Empresa"
        : "Trabajador"
      : ""
      let listaDeRoles = item.Permits
        ? item.Permits.includes("[")
          ? JSON.parse(item.Permits)
          : [JSON.parse(item.Permits)]
        : []

      let listaDeRolesSolicitados = []
      listaDeRoles.forEach(rol => {
        listaDeRolesSolicitados.push(this.props.allRoles.find(r => r.Id === rol).Name + " ")
      })
      item.listaDeRolesSolicitadosString = listaDeRolesSolicitados + ""
    });

    return (
      <React.Fragment>
        {this.renderModal()}

        {this.props.isLoading && <LoadingOverlay />}
        <TableFilter
          placeholder="Buscar"
          onChange={this.handleFilterChange}
          show={this.props.solicitudes != null}
          buttons={
            {
              filter: { buttonName: "iconFilter", visible: false, buttonAction: null },
              document: { buttonName: "iconDocument", visible: false, buttonAction: null },
              download: { buttonName: "iconDownload", visible: false, buttonAction: null },
              newItem: { buttonName: "custom", visible: false, buttonAction: null },

            }
          }

        />
        <DataGrid
          showBorders={false}
          noDataText="Sin solicitudes"
          showColumnLines={false}
          className="custom-table"
          showRowLines={false}
          rowAlternationEnabled
          ref={(ref) => ref !== null ? this.tableRef = ref.instance : null}
          loadPanel={{
            enabled: false,
          }}
          paging={{ pageSize: 10 }}
          pager={{
            showPageSizeSelector: true,
            allowedPageSizes: [5, 10, 20],
            showInfo: true,
          }}
          dataSource={solicitudesEdited}
        >
          <Column
            allowSearch
            caption="Trabajador"
            calculateCellValue={(rowData) => `${rowData.FirstName} ${rowData.LastName} ${rowData.RUT}`}
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <UserInfoColumn
                  nombre={`${row.data.FirstName} ${row.data.LastName}`}
                  rut={row.data.RUT}
                />
                , element
              )
            }}
          />

          <Column
            allowSearch
            caption="Contacto"
            calculateCellValue={(rowData) => `${rowData.Email} ${rowData.CellPhoneNumber}`}
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <UserInfoColumn
                  email={row.data.Email}
                  rut={row.data.CellPhoneNumber || ""}
                />
                , element
              )
            }}
          />

          <Column
            dataField="tipoDeRol"
            caption="Tipo de rol"
            allowSearch
          />
          <Column
            dataField="listaDeRolesSolicitadosString"
            caption="Permiso solicitado"
            allowSearch
          />
          <Column
            caption="Fecha de solicitud"
            dataField="LastReminderDate"
            dataType="date"
            allowSearch
          />
          <Column
            alignment="right"
            cellTemplate={(element, e) => {
              ReactDOM.render(
                <ActionButton
                  text="Gestionar"
                  type="success"
                  className="slimButton"
                  onClick={() => this.handleGestion(e.data, this.state.roleType)}
                />
                , element
              )
            }}
          />
        </DataGrid>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userAccessIds: state.global.userAccessIds,
  solicitudes: state.aprobarSolicitudes.solicitudes,
  isLoading: state.aprobarSolicitudes.isLoading,
  roles: state.asignacionRoles.roles,
  allRoles: state.mantenedores.roles,
  rolesPortalEmpresa: state.asignacionRoles.rolesPortalEmpresa,
  isOpenSelectRoles: state.asignacionRoles.isOpenSelectRoles,
  selectedTrabajador: state.asignacionRoles.selectedTrabajador,
  listaEmpresas: state.global.listaEmpresas,
  currentRoles: state.solicitudes.rolesCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(AprobarSolicitudes);
